import React from 'react';
import Loader from '@lwt-helix/loader';
import Table from '../../../common/components/table/agGrid/Table';
import { tableViews } from '../../../common/components/table/agGrid/tableViews';
import { lostAgentsTooltips, agentsGainedTooltips } from '../constants';
import { breakdownAdditionalHeaders } from '../tableSettings';
import PropTypes from 'prop-types';
import { getColumnsFromTableView } from '../../../common/helpers/table';

export const CommonBreakdownResults = ({ data, isLoading, tableView, gridRef, isOfficeListBreakdown }) => {
    if (isLoading) return <Loader />;

    const settingsbyTableViewId = {
        [tableViews.agentsGainedBreakdown().id]: {
            tooltips: agentsGainedTooltips,
            filterFunction: (agent) => (
                isOfficeListBreakdown ? !agent.didLeaveSelectedOffices : agent.didLeaveSelectedOffices
            )
        },
        [tableViews.lostAgentsBreakdown().id]: {
            tooltips: lostAgentsTooltips,
            filterFunction: (agent) => (
                isOfficeListBreakdown ? agent.didLeaveSelectedOffices : !agent.didLeaveSelectedOffices
            )
        }
    }

    const filteredAgents = data?.results?.filter(agent =>
        settingsbyTableViewId[tableView.id].filterFunction(agent)
    ) || [];

    const tooltips = settingsbyTableViewId[tableView.id]?.tooltips;
    const columns = getColumnsFromTableView(tableView);

    return (
        <Table
            gridRef={gridRef}
            tableView={tableView}
            rowData={filteredAgents}
            tableTitleWithTooltips={tooltips}
            additionalTableHeaders={breakdownAdditionalHeaders}
            externalParams={{
                tooltipTargetPrefix: tableView.id,
            }}
            columns={columns}
        />
    );
}

CommonBreakdownResults.propTypes = {
    data: PropTypes.shape({
        results: PropTypes.array,
        totals: PropTypes.object,
        error: PropTypes.any
    }),
    isLoading: PropTypes.bool,
    tableView: PropTypes.object.isRequired,
    gridRef: PropTypes.object.isRequired,
    isOfficeListBreakdown: PropTypes.bool.isRequired,
};
